export const vantageScoreToProspectorGrade = (score) => {
    switch (score) {
        case 'VANTAGE_SCORE_BUCKET_800_UP':
            return 'A1';
        case 'VANTAGE_SCORE_BUCKET_750_799':
            return 'A2';
        case 'VANTAGE_SCORE_BUCKET_725_749':
            return 'A3';
        case 'VANTAGE_SCORE_BUCKET_700_724':
            return 'B1';
        case 'VANTAGE_SCORE_BUCKET_680_699':
            return 'B2';
        case 'VANTAGE_SCORE_BUCKET_625_679':
            return 'C1';
        case 'VANTAGE_SCORE_BUCKET_580_624':
            return 'C2';
        case 'VANTAGE_SCORE_BUCKET_525_579':
            return 'D1';
        case 'VANTAGE_SCORE_BUCKET_450_524':
            return 'D2';
        default:
            return '';
    }
};
export const vantageScoreToLetterGrade = (score) => {
    switch (score) {
        case 'VANTAGE_SCORE_BUCKET_800_UP':
        case 'VANTAGE_SCORE_BUCKET_750_799':
            return 'A';
        case 'VANTAGE_SCORE_BUCKET_725_749':
        case 'VANTAGE_SCORE_BUCKET_700_724':
        case 'VANTAGE_SCORE_BUCKET_680_699':
            return 'B';
        case 'VANTAGE_SCORE_BUCKET_625_679':
        case 'VANTAGE_SCORE_BUCKET_580_624':
            return 'C';
        case 'VANTAGE_SCORE_BUCKET_525_579':
            return 'D';
        case 'VANTAGE_SCORE_BUCKET_450_524':
            return 'F';
        default:
            return '';
    }
};
//# sourceMappingURL=vantage-score-to-letter-grade.js.map